module.exports = __webpack_public_path__ + "static/media/shutterstock_2024183798.90fbf079.png";